module.exports = __webpack_public_path__ + "img/logo.8dc24805.png";